import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useDevice } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import styles from './MobileGroupingCard.module.scss';
export const GetMobileGroupingCardTID = (parentTestId)=>getTestIds(parentTestId);
export const MobileGroupingCard = (param)=>{
    let { children, testId } = param;
    const { isMobileDevice } = useDevice();
    const { MobileGroupingCardTestIds } = useMemo(()=>GetMobileGroupingCardTID(testId), [
        testId
    ]);
    if (!isMobileDevice) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ _jsx("div", {
        className: styles.card,
        "data-testid": MobileGroupingCardTestIds.Root(),
        children: children
    });
};
